import { NavigationMenuLink } from "@/components/ui/navigation-menu";
import { Link } from "@/i18n/navigation";
import { ComponentProps } from "react";

type LinkProps = ComponentProps<typeof Link> & {
  title: string;
};

const MenuLink = ({ className, ...props }: LinkProps) => {
  return (
    <NavigationMenuLink asChild>
      <Link className={"pl-5 " + (className ?? "")} href={props.href}>
        {props.title}
      </Link>
    </NavigationMenuLink>
  );
};

export default MenuLink;
